import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    modeActive:0
  },
  mutations: {
    set_modeActive(state,idx) {
      state.modeActive = idx
    }
  },
  getters:{
    modeActive:state=>state.modeActive
  },
  actions: {
  },
  modules: {
  }
})
